import { DataBean } from "../DataBean";

export class FreightType extends DataBean {



    public async deleteFreightType(idFreightType: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteFreightType_Number", [idFreightType]);
    }

    public async getFreightTypeCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFreightTypeCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}